"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * ...
 *
 * @author JMt
 */


var Theme =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Theme, _DomainObject_1$Domai);

  /**
   * Creates new object of theme.
   *
   * @param id the id of theme
   * @param name theme name
   * @param description Description of theme
   * @param validFrom Starting date of validity
   * @param validTo Ending date of validity
   */
  function Theme(id, name, description, validFrom, validTo) {
    var _this;

    _classCallCheck(this, Theme);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Theme).call(this));
    _this.id = id;
    _this.name = name;
    _this.description = description;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }

  return Theme;
}(DomainObject_1.DomainObject);

exports.Theme = Theme;

Theme.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Theme.name);
  return {
    id: builder.id('id'),
    description: builder.opt(builder.str('description')).withDescription({
      multiline: true
    }),
    name: builder.trimStr('name', new StringLengthValidator_1.StringLengthValidator(1, 255)),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
  };
}();